import { Box, Button, Checkbox, Grid, TextField, Typography, Link as MuiLink, InputAdornment, IconButton } from "@mui/material";
import { useState } from "react";
import { FaChevronRight, FaEye, FaEyeSlash } from "react-icons/fa6";
import { Link } from "react-router-dom";
import { useAuth } from "../../../../contexts/AuthProvider";
import AppCard from "../../../../components/ui/AppCard";

export const LoginForm = () => {

    const { signIn, isLoading } = useAuth();

    const [showPassword, setShowPassword] = useState(false);

    const [formData, setFormData] = useState({
        user: '',
        password: '',
        agree: false,
    });

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        signIn(formData);
    };

    const styles = {
        textField: { mb: '1rem' },
        checkBoxContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            mb: '1rem'
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    };

    return (
        <Grid size={{ xs: 12, md: 6 }}>
            <AppCard>
            <Box component={'form'}
                onSubmit={handleSubmit}
            >
                <TextField
                    required
                    fullWidth
                    sx={styles.textField}
                    label="Usuário"
                    name="user"
                    value={formData.user}
                    onChange={handleChange}
                />
                <TextField
                    required
                    fullWidth
                    sx={styles.textField}
                    label="Senha"
                    type={showPassword ? 'text' : 'password'}
                    name="password"
                    value={formData.password}
                    onChange={handleChange}
                    InputProps={{
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() => setShowPassword((s) => !s)}
                                    edge="end"
                                    aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                                >
                                    {showPassword ? <FaEyeSlash size={18} /> : <FaEye size={18} />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <Box sx={styles.checkBoxContainer}>
                    <Checkbox
                        required
                        name="agree"
                        checked={formData.agree}
                        onChange={handleChange}
                    />
                    <Typography>
                        Concordo com os Termos de Uso e Políticas de Privacidade
                    </Typography>
                </Box>
                <Box sx={styles.buttonContainer}>
                    <Button
                        startIcon={<FaChevronRight size={15} />}
                        variant="contained"
                        color="secondary"
                        type="submit"
                        disabled={isLoading}
                    >
                        Fazer Login
                    </Button>

                    <MuiLink component={Link} to="/redefinir-senha" sx={{ color: 'text.secondary' }}>
                        Esqueceu a senha?
                    </MuiLink>
                </Box>
            </Box>
            </AppCard>
        </Grid>
    );
};